var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import axios, {} from "axios";
import { BAlert, BButton, BForm, BFormCheckbox, BFormGroup } from "bootstrap-vue";
import { computed, onMounted, ref } from "vue";
import Multiselect from "vue-multiselect";
import { useConfig } from "@/composables/config";
import { withPrefix } from "@/utils/redirect";
import { errorMessageAsString } from "@/utils/simple-error";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ExternalLogin',
    props: {
        loginPage: { type: Boolean, default: false },
        excludeIdps: { default: () => [] }
    },
    setup(__props) {
        const props = __props;
        const { config, isConfigLoaded } = useConfig();
        const loading = ref(false);
        const messageText = ref(null);
        const messageVariant = ref(null);
        const cILogonIdps = ref([]);
        const selected = ref(null);
        const rememberIdp = ref(false);
        const cilogonOrCustos = ref(null);
        const toggleCilogon = ref(false);
        const oIDCIdps = computed(() => (isConfigLoaded.value ? config.value.oidc : {}));
        const filteredOIDCIdps = computed(() => {
            const exclude = ["cilogon", "custos"].concat(props.excludeIdps);
            const filtered = Object.assign({}, oIDCIdps.value);
            exclude.forEach((idp) => {
                delete filtered[idp];
            });
            return filtered;
        });
        const cilogonListShow = computed(() => {
            return oIDCIdps.value.cilogon || oIDCIdps.value.custos;
        });
        const cILogonEnabled = computed(() => oIDCIdps.value.cilogon);
        const custosEnabled = computed(() => oIDCIdps.value.custos);
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            rememberIdp.value = getIdpPreference() !== null;
            // Only fetch CILogonIDPs if custos/cilogon configured
            if (cilogonListShow.value) {
                yield getCILogonIdps();
            }
        }));
        function toggleCILogon(idp) {
            toggleCilogon.value = !toggleCilogon.value;
            cilogonOrCustos.value = toggleCilogon.value ? idp : null;
        }
        function submitOIDCLogin(idp) {
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                try {
                    const loginUrl = withPrefix(`/authnz/${idp}/login`);
                    const urlParams = new URLSearchParams(window.location.search);
                    const redirectParam = urlParams.get("redirect");
                    const formData = new FormData();
                    formData.append("next", redirectParam || "");
                    const { data } = yield axios.post(loginUrl, formData, { withCredentials: true });
                    if (data.redirect_uri) {
                        window.location = data.redirect_uri;
                    }
                }
                catch (e) {
                    messageVariant.value = "danger";
                    messageText.value = errorMessageAsString(e, "Login failed for an unknown reason.");
                }
                finally {
                    loading.value = false;
                }
            });
        }
        function submitCILogon(idp) {
            return __awaiter(this, void 0, void 0, function* () {
                if (props.loginPage) {
                    setIdpPreference();
                }
                if (!selected.value || !idp) {
                    messageVariant.value = "danger";
                    messageText.value = "Please select an institution.";
                    return;
                }
                loading.value = true;
                try {
                    const { data } = yield axios.post(withPrefix(`/authnz/${idp}/login/?idphint=${selected.value.EntityID}`));
                    localStorage.setItem("galaxy-provider", idp);
                    if (data.redirect_uri) {
                        window.location = data.redirect_uri;
                    }
                }
                catch (e) {
                    messageVariant.value = "danger";
                    messageText.value = errorMessageAsString(e, "Login failed for an unknown reason.");
                }
                finally {
                    loading.value = false;
                }
            });
        }
        function getCILogonIdps() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const { data } = yield axios.get(withPrefix("/authnz/get_cilogon_idps"));
                    cILogonIdps.value = data;
                    if (cILogonIdps.value.length == 1) {
                        selected.value = cILogonIdps.value[0];
                    }
                    else {
                        // List is originally sorted by OrganizationName which can be different from DisplayName
                        cILogonIdps.value.sort((a, b) => (a.DisplayName > b.DisplayName ? 1 : -1));
                    }
                    if (props.loginPage) {
                        const preferredIdp = getIdpPreference();
                        if (preferredIdp) {
                            const selectedIdp = cILogonIdps.value.find((idp) => idp.EntityID === preferredIdp);
                            if (selectedIdp) {
                                selected.value = selectedIdp;
                            }
                        }
                    }
                }
                catch (e) {
                    const error = e;
                    messageVariant.value = "danger";
                    const message = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) && error.response.data.err_msg;
                    messageText.value = message || "Failed to fetch CILogon IdPs.";
                }
            });
        }
        function setIdpPreference() {
            if (rememberIdp.value && selected.value) {
                localStorage.setItem("galaxy-remembered-idp", selected.value.EntityID);
            }
            else {
                localStorage.removeItem("galaxy-remembered-idp");
            }
        }
        function getIdpPreference() {
            return localStorage.getItem("galaxy-remembered-idp");
        }
        return { __sfc: true, props, config, isConfigLoaded, loading, messageText, messageVariant, cILogonIdps, selected, rememberIdp, cilogonOrCustos, toggleCilogon, oIDCIdps, filteredOIDCIdps, cilogonListShow, cILogonEnabled, custosEnabled, toggleCILogon, submitOIDCLogin, submitCILogon, getCILogonIdps, setIdpPreference, getIdpPreference, BAlert, BButton, BForm, BFormCheckbox, BFormGroup, Multiselect, LoadingSpan };
    }
});
